import type { ReactNode } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";

import { Toaster } from "@/shared/components/ui/toast";
import { AuthProvider } from "@/shared/contexts/AuthContext";

interface AppProvidersProps {
  children: ReactNode;
}

/** Server-state cache shared by all feature queries. */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Composition root for all application-level providers.
 * Future providers (permissions, theme) are added here, keeping App and
 * main free of provider nesting.
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          {children}
          <Toaster />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
